// extracted by mini-css-extract-plugin
export var borderTop = "_m-3";
export var linkIcon = "_m-5";
export var linkIconSm = "_m-6";
export var linkOutCard = "_m-7 _m-4";
export var linkRow = "_m-2";
export var pageContainer = "_m-1";
export var providerIcon = "_m-8";
export var roundedBorder = "_m-4";
export var settingsContent = "_m-0";